import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, ViewChild, ViewChildren } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal, NgbDatepicker, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { AdditionOfManpowerService } from '../../Model/AdditionReductionOfManpower/addition-of-manpower.service';
import { SessionService } from '../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { NavigationExtras, Router } from '@angular/router';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { DownloadSampleService } from '../../Model/DownloadSample/download-sample.service';
import { CommonService } from '../../Model/Common/common.service';

@Component({
  selector: 'app-designation-wise-detail-summary',
  standalone: true,
  imports: [NgbModule, FormsModule, ReactiveFormsModule, NgSelectModule, CommonModule, NgbDatepicker, DataTablesModule, LoaderComponent],
  templateUrl: './designation-wise-detail-summary.component.html',
  styleUrl: './designation-wise-detail-summary.component.scss'
})
export class DesignationWiseDetailSummaryComponent {
  @Input() InputData: any;
  @Input() DesignationModal: any;
  isDisabled: boolean = false
  Data: any[] = [];
  dtTrigger: Subject<any> = new Subject<any>();
  selectcheck: boolean = false;
  TotalCount = 0;
  @ViewChildren('input') vc: any;
  constructor(
    public activeModal: NgbActiveModal,
    private siteadditionreduction: AdditionOfManpowerService,
    private download: DownloadSampleService,
    private router: Router,
    protected common: CommonService,
  ) {
    this.common.getPageRights();
   }

  ngOnInit(): void {
    console.log(this.InputData);
    this.ESS_SiteManpowerAdditionReductionGet();
  }

  ngAfterViewInit() {
    this.vc.first.nativeElement.focus();
  }

  Edit(element: any) {
    this.DesignationModal.close();
    this.activeModal.close();
    if (element.AllocationType == 'A' || element.AllocationType == 'O') {
      this.router.navigate(['master/AdditionOfManpowerNew/' + element.ESS_ShiftWiseManpowerMasterId + '/' + (element.AllocationType == 'O' ? 'p' : 's')]);
    }
    else if (element.AllocationType == 'R') {
      //this.router.navigate(['master/ReductionOfManpower'], navigationID);
      this.router.navigate(['master/ReductionOfManpowerNew/' + element.ESS_ShiftWiseManpowerMasterId + '/s']);
    }
  }

  Cancel() {
    this.activeModal.close();
  }

  ESS_SiteManpowerAdditionReductionGet() {
    this.isDisabled = true;
    this.siteadditionreduction.ESS_SiteManpowerAdditionReductionGet(this.InputData).subscribe({
      next: (response) => {
        this.Data = Object.values(response.Table);
        this.TotalCount = response.Table.reduce((total: any, element: any) => {
          return total + (element.AllocationType != 'R' ? parseInt(element.NoOfPerson) : parseInt(element.NoOfPerson) * -1);
        }, 0);
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  exportToExcel() {
    this.download.exportToExcel(this.Data, "DesignationWiseDetailData");
  }
}
